/*
  herlamora-cart-progress.js — haelt den Geschenk-Fortschritt auf der
  Produktseite am Warenkorb aktuell.

  Der Startzustand kommt aus Liquid (siehe herlamora-cart-progress.liquid),
  hier wird nur nachgezogen, sobald sich der Warenkorb aendert. Weil das
  Geschenk ueber Corner Cart laeuft und dessen Drawer eigenes JavaScript
  mitbringt, horchen wir breit: auf das Theme-PubSub, auf die ueblichen
  Cart-Events und auf jede Anfrage an /cart* (fetch wie XHR). Danach holen
  wir /cart.js -- eine Quelle fuer alle Instanzen, gebuendelt und entprellt.
*/
(function () {
  'use strict';

  /* Nur veraendernde Aufrufe der Cart-API. /cart.js bewusst nicht: das holen
     wir selbst und wuerden uns sonst endlos neu anstossen. */
  var CART_REQUEST = /\/cart\/(add|change|update|clear)/;
  var REFRESH_DELAY = 150;

  var instances = new Set();
  var refreshTimer = null;
  var inFlight = null;
  var lastTotals = null;

  /* --- Geldformat ---------------------------------------------------------
     Nachbau des klassischen Shopify-Formatters, damit der im Browser
     gerechnete Betrag genauso aussieht wie der aus dem money-Filter. */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number === null) return '0';

    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var value = '';

    switch ((format.match(placeholder) || [])[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2, '.', ',');
    }

    return format.replace(placeholder, value);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fill(template, token, value) {
    return template.split(token).join(value);
  }

  /* --- Warenkorb holen ---------------------------------------------------- */
  function cartUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base + '.js';
  }

  function apply(cart) {
    lastTotals = cart;
    instances.forEach(function (instance) {
      instance.update(cart);
    });
  }

  function fetchCart() {
    if (inFlight) return inFlight;

    inFlight = fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) apply(cart);
      })
      .catch(function () {
        /* Netzwerkfehler: der aus Liquid gerenderte Stand bleibt stehen. */
      })
      .finally(function () {
        inFlight = null;
      });

    return inFlight;
  }

  function scheduleRefresh() {
    if (!instances.size) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(fetchCart, REFRESH_DELAY);
  }

  /* --- Auf Warenkorb-Aenderungen horchen ---------------------------------- */
  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (typeof URL === 'function' && input instanceof URL) return input.href;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function listen() {
    if (window.__herlamoraCartProgressListening) return;
    window.__herlamoraCartProgressListening = true;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
      } catch (error) {
        /* Theme ohne PubSub: die uebrigen Signale reichen. */
      }
    }

    ['cart:updated', 'cart:refresh', 'cart:change', 'corner:cart:updated'].forEach(function (name) {
      document.addEventListener(name, scheduleRefresh);
    });

    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function () {
        var result = originalFetch.apply(this, arguments);
        var url = requestUrl(arguments[0]);

        if (url && CART_REQUEST.test(url) && result && typeof result.then === 'function') {
          result.then(scheduleRefresh, function () {});
        }

        return result;
      };
    }

    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      var target = requestUrl(url);
      this.__herlamoraCartRequest = Boolean(target) && CART_REQUEST.test(target);
      return originalOpen.apply(this, arguments);
    };

    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__herlamoraCartRequest) {
        this.addEventListener('loadend', scheduleRefresh);
      }
      return originalSend.apply(this, arguments);
    };

    /* Kommt der Besucher aus einem anderen Tab zurueck, kann der Warenkorb
       dort veraendert worden sein. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleRefresh();
    });
  }

  /* --- Komponente --------------------------------------------------------- */
  class HerlamoraCartProgress extends HTMLElement {
    connectedCallback() {
      this.milestones = this.readMilestones();
      if (!this.milestones.length) return;

      this.max = this.milestones.reduce(function (highest, milestone) {
        return Math.max(highest, milestone.a);
      }, 0);
      this.topLabel = this.milestones.reduce(function (top, milestone) {
        return milestone.a === this.max ? milestone.l : top;
      }.bind(this), '');

      this.textElement = this.querySelector('[data-progress-text]');
      this.markers = Array.from(this.querySelectorAll('[data-progress-marker]'));
      this.labels = Array.from(this.querySelectorAll('[data-progress-label]'));

      instances.add(this);
      listen();

      if (lastTotals) {
        this.update(lastTotals);
      } else {
        scheduleRefresh();
      }
    }

    disconnectedCallback() {
      instances.delete(this);
    }

    readMilestones() {
      try {
        var parsed = JSON.parse(this.dataset.milestones || '[]');
        return Array.isArray(parsed) ? parsed.filter(function (m) { return m && m.a > 0; }) : [];
      } catch (error) {
        return [];
      }
    }

    total(cart) {
      var value = this.dataset.basis === 'subtotal' ? cart.items_subtotal_price : cart.total_price;
      return typeof value === 'number' ? value : 0;
    }

    update(cart) {
      var total = this.total(cart);
      var percent = Math.max(0, Math.min(100, (total / this.max) * 100));

      this.style.setProperty('--hcp-progress', percent.toFixed(2) + '%');

      this.markers.concat(this.labels).forEach(function (element) {
        element.classList.toggle('is-reached', total >= Number(element.dataset.amount));
      });

      if (this.textElement) this.textElement.innerHTML = this.text(total);
    }

    text(total) {
      var next = this.milestones
        .filter(function (milestone) { return milestone.a > total; })
        .sort(function (a, b) { return a.a - b.a; })[0];

      if (!next) {
        return fill(escapeHtml(this.dataset.textReached || ''), '[ziel]', escapeHtml(this.topLabel || ''));
      }

      var remaining = formatMoney(next.a - total, this.dataset.moneyFormat || '{{ amount_with_comma_separator }} €');
      var template = fill(escapeHtml(this.dataset.textProgress || ''), '[ziel]', escapeHtml(next.l || ''));

      return fill(template, '[betrag]', '<strong>' + remaining + '</strong>');
    }
  }

  if (!customElements.get('herlamora-cart-progress')) {
    customElements.define('herlamora-cart-progress', HerlamoraCartProgress);
  }
})();
